import React, { useContext } from 'react';
export var DropdownContext = /*#__PURE__*/React.createContext(null);
export var useDropdownContext = function useDropdownContext() {
  var value = useContext(DropdownContext);

  if (!value) {
    throw new Error('No dropdown context found. This is typically caused by trying to render DropdownItem, DropdownToggle or DropdownMenu components outside of a Dropdown.');
  }

  return value;
};